<template>
	<div class="grid gap-4">
		<FormKit
			type="loanlinkCurrency"
			name="currentBalance"
			label="Actueel saldo"
		/>
	</div>
</template>
